import styled from 'styled-components';
import { Text, Link } from '@comicrelief/component-library';

const Wrapper = styled.div`
  position: relative;
  width: 100%;
`;

const Inner = styled.div`
  width: 100%;
  max-width: 1335px;
  margin: 0 auto;
  padding: 1rem 2rem;
  color:  ${({ theme, textColour }) => theme.color(textColour)};

  @media ${({ theme }) => theme.allBreakpoints('L')} {
    padding: 1rem 3rem;
  }
`;

const CrumbWrapper = styled.div`
  display: inline-block;
`;

const Crumb = styled(Text)`
  // Will eventually be the default Text font-size via ENG-4394, but for now...
  font-size: 0.875rem;
`;

const Divider = styled(Crumb)`
  margin: 0 0.65rem;
`;

const BreadcrumbLink = styled(Link)`
  &,
  &:hover,
  &:focus {
    color: inherit !important;
  }
`;

export {
  Wrapper, Inner, CrumbWrapper, Crumb, Divider, BreadcrumbLink
};
